export default function MySQL_ADDDATE() {
  return (
    <div>
      <h2>MySQL_ADDDATE</h2>    </div>
  );
}